import merge from 'deepmerge';
import React, { useMemo } from 'react';
import { copyObject, dotGet } from '../../utils/utils';
import Colors, { ColorSchemes } from '../colors';
import Theme from '../index';
import ThemeContext from '../ThemeContext';
const applyColors = _ref => {
  let {
    colorsSet,
    colors
  } = _ref;
  const keys = Object.keys(colorsSet);
  for (let i = 0; i < keys.length; i += 1) {
    if (colorsSet[keys[i]]) {
      colorsSet[keys[i]] = dotGet(colors, `${colorsSet[keys[i]]}.color`);
    }
  }
  return colorsSet;
};
const AppThemeProvider = _ref2 => {
  let {
    children,
    colorScheme = ColorSchemes.LIGHT,
    theme: customTheme,
    colors: customColors
  } = _ref2;
  const colors = useMemo(() => {
    let current = Colors[colorScheme];
    if (customColors) {
      current = merge(current, customColors[colorScheme]);
    }
    return current;
  }, [colorScheme, customColors]);
  const theme = useMemo(() => {
    let current = copyObject(Theme);
    if (customTheme) {
      current = merge(current, customTheme);
    }
    applyColors({
      colorsSet: current.fonts.roles.base.colors,
      colors
    });
    applyColors({
      colorsSet: current.fonts.roles.primary.colors,
      colors
    });
    applyColors({
      colorsSet: current.fonts.roles.secondary.colors,
      colors
    });
    applyColors({
      colorsSet: current.fonts.roles.tertiary.colors,
      colors
    });
    applyColors({
      colorsSet: current.fonts.roles.inverted.colors,
      colors
    });
    applyColors({
      colorsSet: current.buttons.roles.primary.colors,
      colors
    });
    applyColors({
      colorsSet: current.buttons.roles.secondary.colors,
      colors
    });
    applyColors({
      colorsSet: current.buttons.roles.neutral.colors,
      colors
    });
    applyColors({
      colorsSet: current.buttons.roles.tertiary.colors,
      colors
    });
    applyColors({
      colorsSet: current.linearProgress.roles.primary.colors,
      colors
    });
    applyColors({
      colorsSet: current.linearProgress.roles.secondary.colors,
      colors
    });
    applyColors({
      colorsSet: current.linearProgress.roles.tertiary.colors,
      colors
    });
    applyColors({
      colorsSet: current.links.roles.primary.colors,
      colors
    });
    applyColors({
      colorsSet: current.links.roles.secondary.colors,
      colors
    });
    applyColors({
      colorsSet: current.links.roles.neutral.colors,
      colors
    });
    applyColors({
      colorsSet: current.links.roles.tertiary.colors,
      colors
    });
    applyColors({
      colorsSet: current.slider.colors.text,
      colors
    });
    applyColors({
      colorsSet: current.slider.colors.content,
      colors
    });
    applyColors({
      colorsSet: current.inputs.colors.font,
      colors
    });
    applyColors({
      colorsSet: current.inputs.colors.background,
      colors
    });
    applyColors({
      colorsSet: current.inputs.colors.border,
      colors
    });
    applyColors({
      colorsSet: current.search.colors.text,
      colors
    });
    applyColors({
      colorsSet: current.search.colors.background,
      colors
    });
    applyColors({
      colorsSet: current.search.colors.border,
      colors
    });
    applyColors({
      colorsSet: current.search.colors.icon,
      colors
    });
    applyColors({
      colorsSet: current.table.colors.header,
      colors
    });
    applyColors({
      colorsSet: current.table.colors.border,
      colors
    });
    applyColors({
      colorsSet: current.checkboxes.states.primary.colors,
      colors
    });
    applyColors({
      colorsSet: current.checkboxes.states.neutral.colors,
      colors
    });
    applyColors({
      colorsSet: current.checkboxes.states.secondary.colors,
      colors
    });
    applyColors({
      colorsSet: current.checkboxes.states.tertiary.colors,
      colors
    });
    applyColors({
      colorsSet: current.radios.states.colors,
      colors
    });
    applyColors({
      colorsSet: current.toggle.thumb.colors,
      colors
    });
    applyColors({
      colorsSet: current.toggle.track.colors,
      colors
    });
    applyColors({
      colorsSet: current.tags.roles.neutral.colors,
      colors
    });
    applyColors({
      colorsSet: current.tags.roles.info.colors,
      colors
    });
    applyColors({
      colorsSet: current.tags.roles.warning.colors,
      colors
    });
    applyColors({
      colorsSet: current.tags.roles.error.colors,
      colors
    });
    applyColors({
      colorsSet: current.tags.roles.success.colors,
      colors
    });
    return current;
  }, [colors, customTheme]);
  const currentTheme = useMemo(() => {
    return {
      colorScheme,
      theme,
      colors
    };
  }, [theme, colors, colorScheme]);
  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: currentTheme
  }, children);
};
export default AppThemeProvider;